


















import mixins from 'vue-typed-mixins';
import { Question } from '@/utils/SurveyUtils';
import { ReportNode, QuestionData } from '@/utils/ReportUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ReportNode<Question, QuestionData>,
    },
  },

  computed: {
    answer(): any {
      return this.value.data?.participation?.answer || {};
    },

    readonly(): boolean {
      return !this.value.data.editable || false;
    },

    rules(): any {
      if (this.value.item.options.rule) {
        // https://logaretm.github.io/vee-validate/advanced/rules-object-expression.html#defining-rules
        return {
          [this.value.item.options.rule]:
            this.value.item.options.rule === 'regex'
              ? this.value.item.options.regex
              : true,
        };
      } else {
        return undefined;
      }
    },
  },

  methods: {
    async handleChange() {
      await (this.$refs.validation as any).validate(this.answer.value);
      this.$emit('dirty');
      if ((this.$refs.validation as any)?.errors?.length > 0) {
        this.value.data.valid = false;
      } else {
        this.value.data.valid = true;
        if (this.value.data.participation) {
          this.value.data.participation.completeness =
            this.answer.value?.length > 0 ? 1 : 0;
        }
      }
    },
  },
});
